import { QueryKeys } from "~/services/queryClient"
import { useQuery } from "@tanstack/react-query"
import { getFlowNamesCampaign } from "~/services/taskService"
import { CodeContext } from "~/protos/agents"

interface UseFlowNamesCampaignProps {
  s3TarFilePath: string
}

const useFlowNamesCampaign = ({
  s3TarFilePath
}: UseFlowNamesCampaignProps) => {
  const hasRequiredFields = Boolean(s3TarFilePath)

  const codeContext: CodeContext = {
    connType: "",
    orgName: "",
    repoName: "",
    branchName: "",
    commitId: "",
    s3TarFilePath
  }

  const { data: flowNames } = useQuery({
    queryKey: [codeContext, ...QueryKeys.FlowNames, ...QueryKeys.Conversations],
    queryFn: ({ queryKey }) => getFlowNamesCampaign(queryKey[0] as CodeContext),
    initialData: null,
    enabled: hasRequiredFields,
    meta: {
      persist: false
    },
    select: (data) => hasRequiredFields && data?.flows?.muleAllFlowNames as string[] || null
  })
  return flowNames
}

export default useFlowNamesCampaign
